import { useTranslation } from 'react-i18next';

import { Redirect, Route, Switch } from '@treams/treams-routes';
import { Container, Jumbo, Tabs } from '@treams/treams-ui';

import useFeature from 'packages/kakapo-ui-application/hooks/useFeature';
import SettingsThemeContainer from 'packages/kakapo-ui-settings-application/pages/theme/SettingsThemeContainer';
import GoalDriverSettingsContainer from 'packages/kakapo-ui-application/pages/goals/create/GoalDriverSettingsContainer';
import SettingsTeams from 'packages/kakapo-ui-settings-application/pages/teams/SettingsTeams';
import SettingsCreateNewTeam from 'packages/kakapo-ui-settings-application/pages/teams/SettingsCreateNewTeam';
import SettingsEditTeamID from 'packages/kakapo-ui-settings-application/pages/teams/SettingsEditTeam';

import Department from './departments/Department';
import OrganizationDepartments from './departments/OrganizationDepartments';
import CreateDepartment from './departments/CreateDepartment';

type RouteParams = { id: string };

export default function OrganizationSettings() {
	const { t } = useTranslation();

	const hasGoals = useFeature('2021.goals');

	return (
		<>
			<Jumbo
				title={t('settings.organization.title')}
				description={t('settings.organization.description')}
				footer={
					<Tabs.Container mb="-1px" wide={1080}>
						<Tabs.Item
							title={t('settings.organizations.departments.title')}
							path="/settings/organization/departments"
							exact={false}
						/>
						<Tabs.Item
							title={t('settings.organizations.teams.title')}
							path="/settings/organization/teams"
							exact={false}
						/>
						<Tabs.Item
							title={t('settings.organizations.theme.title')}
							path="/settings/organization/theme"
						/>
						{hasGoals && (
							<Tabs.Item
								title={t('settings.organizations.drivers.title')}
								path="/settings/organization/drivers"
							/>
						)}
					</Tabs.Container>
				}
				wide={1080}
			/>
			<Switch>
				<Route path="/settings/organization/departments/new">
					<CreateDepartment />
				</Route>
				<Route<RouteParams> path="/settings/organization/departments/:id">
					{({ match }) => <Department id={match!.params.id!} />}
				</Route>
				<Route>
					<Container py={3} wide={1080}>
						<Switch>
							<Route path={['/settings/organization/departments']} exact>
								<OrganizationDepartments />
							</Route>
							<Route path="/settings/organization/teams" exact>
								<SettingsTeams />
							</Route>
							<Route path="/settings/organization/teams/new" exact>
								<SettingsCreateNewTeam />
							</Route>
							<Route<RouteParams> path="/settings/organization/teams/:id" exact>
								{({ match }) => <SettingsEditTeamID id={match!.params.id!} />}
							</Route>
							<Route path="/settings/organization/theme">
								<SettingsThemeContainer />
							</Route>
							<Route path="/settings/organization/drivers">
								<GoalDriverSettingsContainer />
							</Route>
							<Route>
								<Redirect to="/settings/organization/departments" />
							</Route>
						</Switch>
					</Container>
				</Route>
			</Switch>
		</>
	);
}
